import React, { useState, useEffect } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL, listAll } from "firebase/storage";
import { auth } from "../firebase-config"; // Ensure this is properly initialized

function CloudStorage() {
  const [file, setFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (auth.currentUser) {
      setUserId(auth.currentUser.uid);
      fetchUserFiles();
    }
  }, [auth.currentUser]);

  const fetchUserFiles = async () => {
    const storageRef = ref(getStorage(), `userFiles/${auth.currentUser.uid}`);
    const fileList = await listAll(storageRef);
    const files = await Promise.all(
      fileList.items.map(async (fileRef) => {
        const url = await getDownloadURL(fileRef);
        return { name: fileRef.name, url };
      })
    );
    setUploadedFiles(files);
  };

  const handleFileUpload = async () => {
    if (!file || !userId) return;
    const storageRef = ref(getStorage(), `userFiles/${userId}/${file.name}`);
    await uploadBytes(storageRef, file);
    fetchUserFiles(); // Refresh file list after upload
  };

  return (
    <div>
      <h2>My Cloud Storage</h2>
      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <button onClick={handleFileUpload}>Upload File</button>

      <h3>Uploaded Files</h3>
      <ul>
        {uploadedFiles.map((file, index) => (
          <li key={index}>
            <a href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default CloudStorage;
